export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/vr_360_video.7214de0.svg";